import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\PhanThiCamGiang\\onegate\\client\\core\\node_modules\\next-intl\\dist\\esm\\shared\\NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\PhanThiCamGiang\\onegate\\client\\core\\src\\app\\[locale]\\(cust)\\(public)\\public-statistics\\_components\\public-statistics-management.tsx");
;
import(/* webpackMode: "eager" */ "D:\\PhanThiCamGiang\\onegate\\client\\core\\src\\components\\custom-page\\custom-page-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["getLocalStorage","LocalStorageKeys","Locale"] */ "D:\\PhanThiCamGiang\\onegate\\client\\core\\src\\lib\\local-storage.ts");
